import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import 'powerbi-client';
import PowerBIApi from '@src/api/PowerBIApi';
import { genPBIBasicFilter } from '@src/utils/helpers/powerbi';

import ApiActions from '@src/action/ActionFactory';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { pushGAAction } from '@src/utils/gtm';
import { media } from '../../../utils/style-utils';

const pageHeaderHeight = 52;
const dashboardHeaderHeight = {
  driver: 120,
  vehicle: 160
};

function getPageHeaderHeight(props) {
  return pageHeaderHeight + (dashboardHeaderHeight[props.type] || 0);
}

const HolderPanel = styled.div`
  height: calc(100vh - ${pageHeaderHeight}px);

  ${media.desktop`
    height: calc(100vh - ${getPageHeaderHeight}px);
  `}

  & > div {
    height: 100%;
  }

  && iframe {
    height: 100%;
    border: none;
    html,
    body {
      background: transparent;
    }
  }
`;

class DashboardEmbed extends PureComponent {
  state = {
    activeDriverId: null,
    activeLeaseId: null
  };

  constructor(props) {
    super();

    const { activeDriverId, activeLeaseId } = props;
    this.state = {
      activeDriverId,
      activeLeaseId
    };
  }

  componentDidMount() {
    this.loadEmbed();
  }

  componentDidUpdate(prevProps) {
    const {
      activeDriverId,
      activeLeaseId,
      dashboardType,
      contentId
    } = this.props;
    const {
      activeDriverId: prvActDriverId,
      activeLeaseId: prvActLeaseId,
      contentId: prvContentId
    } = prevProps;

    if (dashboardType === 'driver' && activeLeaseId !== prvActLeaseId) {
      this.setState(
        {
          activeLeaseId
        },
        () => this.loadEmbed()
      );
    }

    if (dashboardType === 'vehicle' && activeDriverId !== prvActDriverId) {
      this.setState(
        {
          activeDriverId
        },
        () => this.loadEmbed()
      );
    }
  }

  getContent(id) {
    return this.props.apiActions.get({
      resource: 'CONTENT',
      id
    });
  }

  getPBIconfig(reportId, countryCode, companyCode) {
    return PowerBIApi.getReportEmbedConfig(countryCode, companyCode, reportId);
  }

  loadEmbed = () => {
    const {
      countryCode,
      companyCode,
      reportId,
      dashboardType,
      registrationNo,
      driverId,
      contentId
    } = this.props;

    const { activeDriverId, activeLeaseId } = this.state;

    if (!this.pbiHolder || !contentId) return;

    let contentMeta;
    let localLeaseId = activeLeaseId;
    const localDriverId = activeDriverId;

    this.getContent(contentId)
      .then(contents => {
        contentMeta = JSON.parse(contents[0].metadata);
        return this.getPBIconfig(contentMeta.refId, countryCode, companyCode);
      })
      .then(conf => {
        conf.pageName = 'ReportSection';
        conf.filters = [
          /driver/gi.test(dashboardType)
            ? genPBIBasicFilter('SRC_DRIVER_ID', driverId)
            : genPBIBasicFilter('Registration_no', registrationNo)
        ];
        conf.settings = {
          filterPaneEnabled: false,
          navContentPaneEnabled: false
        };
        window.powerbi.preload(conf);
        window.powerbi.reset(this.pbiHolder);

        const pbireport = window.powerbi.embed(this.pbiHolder, conf);

        pbireport.on('buttonClicked', event => {
          // console.log('pbi btn clikced', event);
          pushGAAction(
            'PBIReport',
            `BTN::${event.detail.id}::${dashboardType}-profile`,
            '',
            event.detail
          );

          const { id } = event.detail;
          if (contentMeta.actions[id]) {
            const actionDetails = contentMeta.actions[id];
            const transRoute = actionDetails.route
              .replace('${COUNTRY_CODE}', countryCode)
              .replace('${LEASE_ID}', localLeaseId)
              .replace('${DRIVER_ID}', localDriverId);

            this.context.router.push(transRoute);
          }
        });

        pbireport.on('dataSelected', event => {
          // console.log('pbi data selected', event);
          const row = event.detail.dataPoints[0];

          const leaseData = row.identity.find(x =>
            /lease/gi.test(x.target.column)
          );
          if (leaseData) {
            const selLeaseId = leaseData.equals;
            localLeaseId = selLeaseId;
          }
        });
        pbireport.on('buttonClicked', event => {
          // console.log('pbi data buttonClicked', event);
          const row = event.detail.dataPoints[0];

          const leaseData = row.identity.find(x =>
            /lease/gi.test(x.target.column)
          );
          if (leaseData) {
            const selLeaseId = leaseData.equals;
            localLeaseId = selLeaseId;
          }
        });

        // console.log('pbireport', pbireport);
      });
  };

  render() {
    const { dashboardType } = this.props;
    return (
      <HolderPanel type={dashboardType}>
        <div
          ref={node => (this.pbiHolder = node)}
          style={{ width: '100%', height: '100%' }}
        />
      </HolderPanel>
    );
  }
}

DashboardEmbed.contextTypes = {
  router: PropTypes.object
};

const mapActionsToProps = dispatch => ({
  apiActions: bindActionCreators(ApiActions, dispatch)
});

export default connect(null, mapActionsToProps)(DashboardEmbed);



// WEBPACK FOOTER //
// ./src/features/dashboard/components/DashboardEmbed.js